export default function formatRequirement(option: string): { type: string } {
  return {
    type: option,
  };
}
